import facebook from "../../assets/images/icon-facebook.svg";
import twitter from "../../assets/images/icon-twitter.svg";

export const menuData = [
  {
    id: 1,
    title: "Features",
    link: "/features", 
  },
  {
    id: 2,
    title: "Pricing",
    link: "/pricing",
  },
  {
    id: 3,
    title: "Contact",
    link: "/contact",
  },
];

export const btnData = {
  title: "Login",
  link: "/login",
};

export const socialData = [
  {
    id: 1,
    title: "facebook",
    image: facebook,
    link: "/facebook",
  },
  {
    id: 2,
    title: "twitter",
    image: twitter,
    link: "/facebook",
  },
];
